import Vue from 'vue'
import _ from 'lodash'
import { Chart, ChartConfiguration, ChartData, ChartOptions, registerables } from 'chart.js'
Chart.register(...registerables)
import ChartDataLabels from 'chartjs-plugin-datalabels'
Chart.register(ChartDataLabels)
import SuiviRecueilOutput from './models/SuiviRecueilOutput'
import mixins from 'vue-typed-mixins'
import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'

const colors = ['#7fdbff', '#0074d9', '#01ff70', '#001f3f', '#39cccc', '#3d9970', '#2ecc40', '#ff4136', '#85144b', '#ff851b', '#b10dc9', '#ffdc00', '#f012be', '#aaaaaa', '#111111', '#dddddd']

export default mixins(mobileTypeMixin).extend({
    data() {
        return {
            companyName: '',
            dateDebut: `${new Date().getFullYear()}-01-01`,
            dateFin: '',

            chart: null as null | Chart<'doughnut', number[], string>,

            suiviRecueil: null as null | SuiviRecueilOutput,
            statutSelectionne: ''
        }
    },
    computed: {
        config(): ChartConfiguration<'doughnut', number[], string> {
            const baseOptions: ChartOptions<'doughnut'> = {
                responsive: true,
                plugins: {
                    legend: {
                        fullSize: true,
                        align: 'start',

                        position: this.isMobileDevice() ? 'top' : 'left',
                        onClick: (event, elem) => {
                            //@ts-ignore
                            const data = this.suiviRecueil?.allStatuts[elem.index]
                            if (data) {
                                this.statutSelectionne = data
                            }
                        }
                    },
                    datalabels: {
                        backgroundColor: function(context: any) {
                            return context.dataset.backgroundColor
                        },
                        borderColor: 'white',
                        borderRadius: 25,
                        borderWidth: 2,
                        color: 'white',
                        display: function() {
                            return true
                        },
                        font: {
                            weight: 'bold'
                        },
                        padding: 6,
                        formatter: Math.round
                    }
                },
                // Core options
                layout: {
                    padding: 16
                },
                animation: {
                    duration: 500
                }
            }

            if (!this.suiviRecueil)
                return {
                    type: 'doughnut' as 'doughnut',
                    data: {
                        labels: [],
                        datasets: []
                    },
                    options: baseOptions
                }

            const labels = this.suiviRecueil.allStatuts
                .map(statut => statut)
                .sort((a, b) => a.localeCompare(b))
                .filter(function(x): x is string {
                    return x !== undefined
                })
            const data = this.suiviRecueil.allStatuts
                .sort((a, b) => a.localeCompare(b))
                .map(statut => this.suiviRecueil?.detailTetes[statut].nombre)
                .filter(function(x): x is number {
                    return x !== undefined
                })

            const datas: ChartData<'doughnut', number[], string> = {
                labels: labels,
                datasets: [
                    {
                        label: `Têtes prélevées sur la période`,
                        data: data,
                        backgroundColor: data.map((x, index) => colors[index]),
                        datalabels: {
                            display: false
                        }
                    }
                ]
            }

            const options = Object.assign(baseOptions, {
                onClick: () => {
                    if (!this.chart) return

                    const activeEl = this.chart.getActiveElements()
                    if (activeEl.length == 0) return null

                    if (!this.chart.data.labels) return

                    const data = this.suiviRecueil?.allStatuts[activeEl[0].index]
                    if (data) {
                        this.statutSelectionne = data
                    }
                }
            })

            return {
                type: 'doughnut',
                data: datas,
                options: options
            }
        },
        listeMessagesStatutSelectionne(): { label: string; data: any }[] | undefined {
            if (this.suiviRecueil && this.statutSelectionne) {
                const labels = this.suiviRecueil.detailTetes[this.statutSelectionne].allMessages
                return _.chain(labels)
                    .map(name => {
                        return {
                            data: this.suiviRecueil?.detailTetes[this.statutSelectionne].messages[name],
                            label: name
                        }
                    })
                    .filter(function(x) {
                        return x.data !== undefined
                    })
                    .orderBy(a => a.label)
                    .value()
            }
        }
    },
    methods: {
        formatDate(date: string) {
            if (!date) return ''
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        loadSuiviRecueil(chirurgien: string | null) {
            this.suiviRecueil = null
            this.statutSelectionne = ''

            if (!this.companyName) return

            this.$loader.go()

            return this.$http
                .api(`suiviRecueil/synthese`)
                .post({ name: this.companyName, dateDebut: this.formatDate(this.dateDebut), dateFin: this.formatDate(this.dateFin), chirurgien : chirurgien })
                .then(x => {
                    this.suiviRecueil = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        reloadChart(chirurgien: string | null) {
            const loadSuiviRecueil = this.loadSuiviRecueil(chirurgien)
            if (loadSuiviRecueil) loadSuiviRecueil.then(() => this.generateChart())
        },
        generateChart() {
            if (!this.config) return

            if (this.chart) this.chart.destroy()

            const canvas = document.getElementById('ctx-chart')
            if (!canvas) return

            const ctx = (canvas as HTMLCanvasElement).getContext('2d')
            if (!ctx) return

            this.chart = new Chart(ctx, this.config)
        }
    }
})
